/* Global Size Chart Data */
/* Top Wear body measurements Size Chart */
const inchToCm = (inch) => (parseFloat(inch) * 2.54).toFixed(1);

const sizeData = [
  { size: 'XS', uk: [6], eur: [32], bust: [32, 33], waist: [26, 27], hip: [36, 37], toplength: [23.5, 25.5], minilength: [33.5, 35.5], kneelength: [37.5, 39.5], midilength: [41.5, 43.5], anklelength: [49.5, 50.5], maxilength: [51.5, 52.5] },
  { size: 'S', uk: [8], eur: [34], bust: [34, 35], waist: [28, 29], hip: [38, 39], toplength: [24, 26], minilength: [34, 36], kneelength: [38, 40], midilength: [42, 44], anklelength: [50, 51], maxilength: [52, 53] },
  { size: 'M', uk: [10], eur: [36], bust: [36, 37], waist: [30, 31], hip: [40, 41], toplength: [24.5, 26.5], minilength: [34.5, 36.5], kneelength: [38.5, 40.5], midilength: [42.5, 44.5], anklelength: [50.5, 51.5], maxilength: [52.5, 53.5] },
  { size: 'L', uk: [12], eur: [38], bust: [38, 39], waist: [32, 33], hip: [42, 43], toplength: [25, 27], minilength: [35, 37], kneelength: [39, 41], midilength: [43, 45], anklelength: [51, 52], maxilength: [53, 54] },
  { size: 'XL', uk: [14], eur: [40], bust: [40, 41], waist: [34, 35], hip: [44, 45], toplength: [25.5, 27.5], minilength: [35.5, 37.5], kneelength: [39.5, 41.5], midilength: [43.5, 45.5], anklelength: [51.5, 52.5], maxilength: [53.5, 54.5] },
  { size: 'XXL', uk: [16], eur: [42], bust: [42, 43], waist: [36, 37], hip: [46, 47], toplength: [25.75, 27.75], minilength: [35.75, 37.75], kneelength: [39.75, 41.75], midilength: [43.75, 45.75], anklelength: [51.75, 52.75], maxilength: [53.75, 54.75] },
  { size: '3XL', uk: [18], eur: [44], bust: [44, 45], waist: [38, 39], hip: [48, 49], toplength: [26, 28], minilength: [36, 38], kneelength: [40, 42], midilength: [44, 46], anklelength: [52, 53], maxilength: [54, 55] },
  { size: '4XL', uk: [20], eur: [46], bust: [46, 47], waist: [40, 41], hip: [50, 51], toplength: [26.25, 28.25], minilength: [36.25, 38.25], kneelength: [40.25, 42.25], midilength: [44.25, 46.25], anklelength: [52.25, 53.25], maxilength: [54.25, 55.25] },
  { size: '5XL', uk: [22], eur: [48], bust: [48, 49], waist: [42, 43], hip: [52, 53], toplength: [26.50, 28.50], minilength: [36.50, 38.50], kneelength: [40.50, 42.50], midilength: [44.50, 46.50], anklelength: [52.50, 53.50], maxilength: [54.50, 55.50] },
  { size: '6XL', uk: [24], eur: [50], bust: [50, 51.125], waist: [44, 45.25], hip: [54, 55], toplength: [28.37, 29.12], minilength: [38.5, 40.5], kneelength: [42.5, 44.5], midilength: [46.5, 48.5], anklelength: [53.5, 54.37], maxilength: [55.5, 56.25] },
  { size: '7XL', uk: [26], eur: [52], bust: [52, 53.12], waist: [46, 47.25], hip: [56, 57], toplength: [29.12, 30], minilength: [40.5, 42.5], kneelength: [44.5, 46.5], midilength: [48.5, 50.5], anklelength: [54.375, 55.12], maxilength: [56.25, 57] },
];

const createTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>UK</th>
          <th>EUR</th>
          <th>Bust (${unit})</th>
          <th>Waist (${unit})</th>
          <th>Hip (${unit})</th>
          <th>Top Length (${unit})</th>
          <th>Mini Length (${unit})</th>
          <th>Knee Length (${unit})</th>
          <th>Midi Length (${unit})</th>
          <th>Ankle Length (${unit})</th>
          <th>Maxi Length (${unit})</th>
        </tr>
      </thead>
      <tbody>
  `;

  sizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(row.uk?.[0])}</td>
        <td>${safeSpan(row.eur?.[0])}</td>
        <td>${safeSpan(convert(row.bust?.[0]))} ${safeSpan(convert(row.bust?.[1]))}</td>
        <td>${safeSpan(convert(row.waist?.[0]))} ${safeSpan(convert(row.waist?.[1]))}</td>
        <td>${safeSpan(convert(row.hip?.[0]))} ${safeSpan(convert(row.hip?.[1]))}</td>
        <td>${safeSpan(convert(row.toplength?.[0]))} ${safeSpan(convert(row.toplength?.[1]))}</td>
        <td>${safeSpan(convert(row.minilength?.[0]))} ${safeSpan(convert(row.minilength?.[1]))}</td>
        <td>${safeSpan(convert(row.kneelength?.[0]))} ${safeSpan(convert(row.kneelength?.[1]))}</td>
        <td>${safeSpan(convert(row.midilength?.[0]))} ${safeSpan(convert(row.midilength?.[1]))}</td>
        <td>${safeSpan(convert(row.anklelength?.[0]))} ${safeSpan(convert(row.anklelength?.[1]))}</td>
        <td>${safeSpan(convert(row.maxilength?.[0]))} ${safeSpan(convert(row.maxilength?.[1]))}</td>
      </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};

document.querySelectorAll('.size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.sizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createTable(true);
  });

  // Initial table
  container.innerHTML = createTable(false);
});


/* Bottom Wear body measurements Size Chart */
const bottomWearSizeData = [
  { size: 'XS', uk: [6], eur: [32], waist: [26, 27], hip: [36, 37], thigh: [19.75], fulllength: [37.63], calflength: [27.63] },
  { size: 'S', uk: [8], eur: [34], waist: [28, 29], hip: [38, 39], thigh: [21.00], fulllength: [38.00], calflength: [28.00] },
  { size: 'M', uk: [10], eur: [36], waist: [30, 31], hip: [40, 41], thigh: [22.25], fulllength: [38.38], calflength: [28.38] },
  { size: 'L', uk: [12], eur: [38], waist: [32, 33], hip: [42, 43], thigh: [23.50], fulllength: [38.75], calflength: [28.75] },
  { size: 'XL', uk: [14], eur: [40], waist: [34, 35], hip: [44, 45], thigh: [24.75], fulllength: [39.13], calflength: [29.13] },
  { size: 'XXL', uk: [16], eur: [42], waist: [36, 37], hip: [46, 47], thigh: [26.00], fulllength: [39.50], calflength: [29.50] },
  { size: '3XL', uk: [18], eur: [44], waist: [38, 39], hip: [48, 49], thigh: [27.25], fulllength: [39.88], calflength: [29.88] },
  { size: '4XL', uk: [20], eur: [46], waist: [40, 41], hip: [50, 51], thigh: [28.50], fulllength: [40.25], calflength: [30.25] },
  { size: '5XL', uk: [22], eur: [48], waist: [42, 43], hip: [52, 53], thigh: [29.75], fulllength: [40.63], calflength: [30.63] },
  { size: '6XL', uk: [24], eur: [50], waist: [44, 45.25], hip: [54, 55.125], thigh: [30.75], fulllength: [41.37], calflength: [] },
  { size: '7XL', uk: [26], eur: [52], waist: [46, 47.25], hip: [56, 57.12], thigh: [31.875], fulllength: [41.75], calflength: [] },
];

const createBottomTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>UK</th>
          <th>EUR</th>
          <th>Waist (${unit})</th>
          <th>Hip (${unit})</th>
          <th>Thigh (${unit})</th>
          <th>Full Length (${unit})</th>
          <th>Calf Length (${unit})</th>
        </tr>
      </thead>
      <tbody>
  `;

  bottomWearSizeData.forEach(row => {
    const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
    const convert = (val) => {
      if (val === undefined) return;
      if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
      return val;
    };

    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(row.uk?.[0])}</td>
        <td>${safeSpan(row.eur?.[0])}</td>
        <td>
          ${safeSpan(convert(row.waist?.[0]))} ${safeSpan(convert(row.waist?.[1]))}
        </td>
        <td>
          ${safeSpan(convert(row.hip?.[0]))} ${safeSpan(convert(row.hip?.[1]))}
        </td>
        <td>
          ${safeSpan(convert(row.thigh?.[0]))} ${safeSpan(convert(row.thigh?.[1]))}
        </td>
        <td>
          ${safeSpan(convert(row.fulllength?.[0]))} ${safeSpan(convert(row.fulllength?.[1]))}
        </td>
        <td>
          ${safeSpan(convert(row.calflength?.[0]))} ${safeSpan(convert(row.calflength?.[1]))}
        </td>
      </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};

document.querySelectorAll('.bottom-wear-chart').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.bottomSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createBottomTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createBottomTable(true);
  });

  // Initial table
  container.innerHTML = createBottomTable(false);
});



/* --------------------------------------------------------------------------------------------------------------------------- */

 
/* Dresses body measurements Size Chart */

const dressesSizeData = [
  { size: 'XS', bust: [32, 33], waist: [26, 27], hip: [36, 37], minilength: [33, 35], kneelength: [37, 39], midilength: [41, 43], anklelength: [49, 50], maxilength: [51, 52] },
  { size: 'S', bust: [34, 35], waist: [28, 29], hip: [38, 39], minilength: [34, 36], kneelength: [38, 40], midilength: [42, 44], anklelength: [50, 51], maxilength: [52, 53] },
  { size: 'M', bust: [36, 37], waist: [30, 31], hip: [40, 41], minilength: [34, 36], kneelength: [38, 40], midilength: [42, 44], anklelength: [50, 51], maxilength: [52, 53] },
  { size: 'L', bust: [38, 39], waist: [32, 33], hip: [42, 43], minilength: [35, 37], kneelength: [39, 41], midilength: [43, 45], anklelength: [51, 52], maxilength: [53, 54] },
  { size: 'XL', bust: [40, 41], waist: [34, 35], hip: [44, 45], minilength: [35, 37], kneelength: [39, 41], midilength: [43, 45], anklelength: [51, 52], maxilength: [53, 54] },
  { size: 'XXL', bust: [42, 43], waist: [36, 37], hip: [46, 47], minilength: [35, 37], kneelength: [39, 41], midilength: [43, 45], anklelength: [51, 52], maxilength: [53, 54] },
  { size: '3XL', bust: [44, 45], waist: [38, 39], hip: [48, 49], minilength: [36, 38], kneelength: [40, 42], midilength: [44, 46], anklelength: [52, 53], maxilength: [54, 55] },
  { size: '4XL', bust: [46, 47], waist: [40, 41], hip: [50, 51], minilength: [36, 38], kneelength: [40, 42], midilength: [44, 46], anklelength: [52, 53], maxilength: [54, 55] },
  { size: '5XL', bust: [48, 49], waist: [42, 43], hip: [52, 53], minilength: [36, 38], kneelength: [40, 42], midilength: [44, 46], anklelength: [52, 53], maxilength: [54, 55] },
  { size: '6XL', bust: [50, 51], waist: [44, 45], hip: [54, 55], minilength: [38, 40], kneelength: [42, 44], midilength: [46, 48], anklelength: [53, 54], maxilength: [55, 56] },
  { size: '7XL', bust: [52, 53], waist: [46, 47], hip: [56, 57], minilength: [40, 42], kneelength: [44, 46], midilength: [48, 50], anklelength: [54, 55], maxilength: [56, 57] },
];

const createDressesTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Bust (${unit})</th>
          <th>Waist (${unit})</th>
          <th>Hip (${unit})</th>
          <th>Mini Length (${unit})</th>
          <th>Knee Length (${unit})</th>
          <th>Midi Length (${unit})</th>
          <th>Ankle Length (${unit})</th>
          <th>Maxi Length (${unit})</th>
        </tr>
      </thead>
      <tbody>
  `;

  dressesSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.bust?.[0]))} ${safeSpan(convert(row.bust?.[1]))}</td>
        <td>${safeSpan(convert(row.waist?.[0]))} ${safeSpan(convert(row.waist?.[1]))}</td>
        <td>${safeSpan(convert(row.hip?.[0]))} ${safeSpan(convert(row.hip?.[1]))}</td>
        <td>${safeSpan(convert(row.minilength?.[0]))} ${safeSpan(convert(row.minilength?.[1]))}</td>
        <td>${safeSpan(convert(row.kneelength?.[0]))} ${safeSpan(convert(row.kneelength?.[1]))}</td>
        <td>${safeSpan(convert(row.midilength?.[0]))} ${safeSpan(convert(row.midilength?.[1]))}</td>
        <td>${safeSpan(convert(row.anklelength?.[0]))} ${safeSpan(convert(row.anklelength?.[1]))}</td>
        <td>${safeSpan(convert(row.maxilength?.[0]))} ${safeSpan(convert(row.maxilength?.[1]))}</td>
      </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};


document.querySelectorAll('.dresses-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.dressesSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createDressesTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createDressesTable(true);
  });

  // Initial table
  container.innerHTML = createDressesTable(false);
});

/* --------------------------------------------------------------------------------------------------------------------------- */

/* Bodysuit measurements Size Chart */
const bodysuitSizeData = [
  { size: 'XS', bust: [32, 33], waist: [26, 27], hip: [36, 37] },
  { size: 'S', bust: [34, 35], waist: [28, 29], hip: [38, 39] },
  { size: 'M', bust: [36, 37], waist: [30, 31], hip: [40, 41] },
  { size: 'L', bust: [38, 39], waist: [32, 33], hip: [42, 43] },
  { size: 'XL', bust: [40, 41], waist: [34, 35], hip: [44, 45] },
  { size: 'XXL', bust: [42, 43], waist: [36, 37], hip: [46, 47] },
  { size: '3XL', bust: [44, 45], waist: [38, 39], hip: [48, 49] },
  { size: '4XL', bust: [46, 47], waist: [40, 41], hip: [50, 51] },
  { size: '5XL', bust: [48, 49], waist: [42, 43], hip: [52, 53] },
  { size: '6XL', bust: [50, 51], waist: [44, 45], hip: [54, 55] },
  { size: '7XL', bust: [52, 53], waist: [46, 47], hip: [56, 57] },
];

const createBodysuitTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Bust (${unit})</th>
          <th>Waist (${unit})</th>
          <th>Hip (${unit})</th>
        </tr>
      </thead>
      <tbody>
  `;

  bodysuitSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.bust?.[0]))} ${safeSpan(convert(row.bust?.[1]))}</td>
        <td>${safeSpan(convert(row.waist?.[0]))} ${safeSpan(convert(row.waist?.[1]))}</td>
        <td>${safeSpan(convert(row.hip?.[0]))} ${safeSpan(convert(row.hip?.[1]))}</td>
      </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};


document.querySelectorAll('.bodysuit-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.bodysuitSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createBodysuitTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createBodysuitTable(true);
  });

  // Initial table
  container.innerHTML = createBodysuitTable(false);
});

/* --------------------------------------------------------------------------------------------------------------------------- */
 
/* Coats and Jackets body measurements Size Chart */

const coatsandjacketsSizeData = [
  { size: 'XS', bust: [32, 33] },
  { size: 'S', bust: [34, 35] },
  { size: 'M', bust: [36, 37] },
  { size: 'L', bust: [38, 39] },
  { size: 'XL', bust: [40, 41] },
  { size: 'XXL', bust: [42, 43] },
  { size: '3XL', bust: [44, 45] },
  { size: '4XL', bust: [46, 47] },
  { size: '5XL', bust: [48, 49] },
  { size: '6XL', bust: [50, 51] },
  { size: '7XL', bust: [52, 53] },
];

const createCoatsandjacketsTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Bust (${unit})</th>
          </tr>
      </thead>
      <tbody>
  `;

  coatsandjacketsSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.bust?.[0]))} ${safeSpan(convert(row.bust?.[1]))}</td>
              </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};


document.querySelectorAll('.coatsandjackets-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.coatsandjacketsSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createCoatsandjacketsTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createCoatsandjacketsTable(true);
  });

  // Initial table
  container.innerHTML = createCoatsandjacketsTable(false);
});

/* --------------------------------------------------------------------------------------------------------------------------- */
/* Co-Ords body measurements Size Chart */
const coordsetsSizeData = [
  { size: 'XS', bust: [32, 33], waist: [26, 27], hip: [36, 37] },
  { size: 'S', bust: [34, 35], waist: [28, 29], hip: [38, 39] },
  { size: 'M', bust: [36, 37], waist: [30, 31], hip: [40, 41] },
  { size: 'L', bust: [38, 39], waist: [32, 33], hip: [42, 43] },
  { size: 'XL', bust: [40, 41], waist: [34, 35], hip: [44, 45] },
  { size: 'XXL', bust: [42, 43], waist: [36, 37], hip: [46, 47] },
  { size: '3XL', bust: [44, 45], waist: [38, 39], hip: [48, 49] },
  { size: '4XL', bust: [46, 47], waist: [40, 41], hip: [50, 51] },
  { size: '5XL', bust: [48, 49], waist: [42, 43], hip: [52, 53] },
  { size: '6XL', bust: [50, 51], waist: [44, 45], hip: [54, 55] },
  { size: '7XL', bust: [52, 53], waist: [46, 47], hip: [56, 57] },
];

const createCoordsetsTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Bust (${unit})</th>
          <th>Waist (${unit})</th>
          <th>Hip (${unit})</th>
        </tr>
      </thead>
      <tbody>
  `;

  coordsetsSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.bust?.[0]))} ${safeSpan(convert(row.bust?.[1]))}</td>
        <td>${safeSpan(convert(row.waist?.[0]))} ${safeSpan(convert(row.waist?.[1]))}</td>
        <td>${safeSpan(convert(row.hip?.[0]))} ${safeSpan(convert(row.hip?.[1]))}</td>
      </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};


document.querySelectorAll('.coordsets-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.coordsetsSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createCoordsetsTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createCoordsetsTable(true);
  });

  // Initial table
  container.innerHTML = createCoordsetsTable(false);
});

/* --------------------------------------------------------------------------------------------------------------------------- */
/* Jumpsuits and Playsuits body measurements Size Chart */
const jumpsuitsandplaysuitsSizeData = [
  { size: 'XS', bust: [32, 33], waist: [26, 27], hip: [36, 37] },
  { size: 'S', bust: [34, 35], waist: [28, 29], hip: [38, 39] },
  { size: 'M', bust: [36, 37], waist: [30, 31], hip: [40, 41] },
  { size: 'L', bust: [38, 39], waist: [32, 33], hip: [42, 43] },
  { size: 'XL', bust: [40, 41], waist: [34, 35], hip: [44, 45] },
  { size: 'XXL', bust: [42, 43], waist: [36, 37], hip: [46, 47] },
  { size: '3XL', bust: [44, 45], waist: [38, 39], hip: [48, 49] },
  { size: '4XL', bust: [46, 47], waist: [40, 41], hip: [50, 51] },
  { size: '5XL', bust: [48, 49], waist: [42, 43], hip: [52, 53] },
  { size: '6XL', bust: [50, 51], waist: [44, 45], hip: [54, 55] },
  { size: '7XL', bust: [52, 53], waist: [46, 47], hip: [56, 57] },
];
const createJumpsuitsandplaysuitsTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Bust (${unit})</th>
          <th>Waist (${unit})</th>
          <th>Hip (${unit})</th>
        </tr>
      </thead>
      <tbody>
  `;

  jumpsuitsandplaysuitsSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.bust?.[0]))} ${safeSpan(convert(row.bust?.[1]))}</td>
        <td>${safeSpan(convert(row.waist?.[0]))} ${safeSpan(convert(row.waist?.[1]))}</td>
        <td>${safeSpan(convert(row.hip?.[0]))} ${safeSpan(convert(row.hip?.[1]))}</td>
      </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};
document.querySelectorAll('.jumpsuitsandplaysuits-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.jumpsuitsandplaysuitsSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createJumpsuitsandplaysuitsTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createJumpsuitsandplaysuitsTable(true);
  });

  // Initial table
  container.innerHTML = createJumpsuitsandplaysuitsTable(false);
});

/* --------------------------------------------------------------------------------------------------------------------------- */

/* Shacket body measurements Size Chart */
const shacketSizeData = [
  { size: 'XS', bust: [32, 33], toplength: [23, 25] },
  { size: 'S', bust: [34, 35], toplength: [24, 26] },
  { size: 'M', bust: [36, 37], toplength: [24, 26] },
  { size: 'L', bust: [38, 39], toplength: [25, 27] },
  { size: 'XL', bust: [40, 41], toplength: [25, 27] },
  { size: 'XXL', bust: [42, 43], toplength: [25, 27] },
  { size: '3XL', bust: [44, 45], toplength: [26, 28] },
  { size: '4XL', bust: [46, 47], toplength: [26, 28] },
  { size: '5XL', bust: [48, 49], toplength: [26, 28] },
  { size: '6XL', bust: [50, 51], toplength: [28, 29] },
  { size: '7XL', bust: [52, 53], toplength: [29, 30] },
];
const createShacketTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Bust (${unit})</th>
          <th>Top Length (${unit})</th>
                  </tr>
      </thead>
      <tbody>
  `;
shacketSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.bust?.[0]))} ${safeSpan(convert(row.bust?.[1]))}</td>
        <td>${safeSpan(convert(row.toplength?.[0]))} ${safeSpan(convert(row.toplength?.[1]))}</td>
        <td>${safeSpan(convert(row.hip?.[0]))} ${safeSpan(convert(row.hip?.[1]))}</td>
      </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};
document.querySelectorAll('.shacket-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.shacketSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createShacketTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createShacketTable(true);
  });

  // Initial table
  container.innerHTML = createShacketTable(false);
});

/* --------------------------------------------------------------------------------------------------------------------------- */

/* Shirts body measurements Size Chart */
const shirtsSizeData = [
  { size: 'XS', bust: [32, 33], toplength: [23, 25] },
  { size: 'S', bust: [34, 35], toplength: [24, 26] },
  { size: 'M', bust: [36, 37], toplength: [24, 26] },
  { size: 'L', bust: [38, 39], toplength: [25, 27] },
  { size: 'XL', bust: [40, 41], toplength: [25, 27] },
  { size: 'XXL', bust: [42, 43], toplength: [25, 27] },
  { size: '3XL', bust: [44, 45], toplength: [26, 28] },
  { size: '4XL', bust: [46, 47], toplength: [26, 28] },
  { size: '5XL', bust: [48, 49], toplength: [26, 28] },
  { size: '6XL', bust: [50, 51], toplength: [28, 29] },
  { size: '7XL', bust: [52, 53], toplength: [29, 30] },
];
const createShirtsTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Bust (${unit})</th>
          <th>Top Length (${unit})</th>
                  </tr>
      </thead>
      <tbody>
  `;
shirtsSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.bust?.[0]))} ${safeSpan(convert(row.bust?.[1]))}</td>
        <td>${safeSpan(convert(row.toplength?.[0]))} ${safeSpan(convert(row.toplength?.[1]))}</td>
              </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};
document.querySelectorAll('.shirts-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.shirtsSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createShirtsTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createShirtsTable(true);
  });

  // Initial table
  container.innerHTML = createShirtsTable(false);
});

/* --------------------------------------------------------------------------------------------------------------------------- */

/* Shrug body measurements Size Chart */

const shrugSizeData = [
  { size: 'XS', bust: [32, 33] },
  { size: 'S', bust: [34, 35] },
  { size: 'M', bust: [36, 37] },
  { size: 'L', bust: [38, 39] },
  { size: 'XL', bust: [40, 41] },
  { size: 'XXL', bust: [42, 43] },
  { size: '3XL', bust: [44, 45] },
  { size: '4XL', bust: [46, 47] },
  { size: '5XL', bust: [48, 49] },
  { size: '6XL', bust: [50, 51] },
  { size: '7XL', bust: [52, 53] },
];

const createShrugTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Bust (${unit})</th>
          </tr>
      </thead>
      <tbody>
  `;

  shrugSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.bust?.[0]))} ${safeSpan(convert(row.bust?.[1]))}</td>
              </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};


document.querySelectorAll('.shrug-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.shrugSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createShrugTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createShrugTable(true);
  });

  // Initial table
  container.innerHTML = createShrugTable(false);
});

/* --------------------------------------------------------------------------------------------------------------------------- */
/* Tops body measurements Size Chart */
const topsSizeData = [
  { size: 'XS', bust: [32, 33], toplength: [23, 25] },
  { size: 'S', bust: [34, 35], toplength: [24, 26] },
  { size: 'M', bust: [36, 37], toplength: [24, 26] },
  { size: 'L', bust: [38, 39], toplength: [25, 27] },
  { size: 'XL', bust: [40, 41], toplength: [25, 27] },
  { size: 'XXL', bust: [42, 43], toplength: [25, 27] },
  { size: '3XL', bust: [44, 45], toplength: [26, 28] },
  { size: '4XL', bust: [46, 47], toplength: [26, 28] },
  { size: '5XL', bust: [48, 49], toplength: [26, 28] },
  { size: '6XL', bust: [50, 51], toplength: [28, 29] },
  { size: '7XL', bust: [52, 53], toplength: [29, 30] },
];
const createTopsTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Bust (${unit})</th>
          <th>Top Length (${unit})</th>
                  </tr>
      </thead>
      <tbody>
  `;
topsSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.bust?.[0]))} ${safeSpan(convert(row.bust?.[1]))}</td>
        <td>${safeSpan(convert(row.toplength?.[0]))} ${safeSpan(convert(row.toplength?.[1]))}</td>
              </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};
document.querySelectorAll('.tops-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.topsSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createTopsTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createTopsTable(true);
  });

  // Initial table
  container.innerHTML = createTopsTable(false);
});

/* --------------------------------------------------------------------------------------------------------------------------- */

/* T-shirt body measurements Size Chart */
const tshirtSizeData = [
  { size: 'XS', bust: [32, 33], toplength: [23, 25] },
  { size: 'S', bust: [34, 35], toplength: [24, 26] },
  { size: 'M', bust: [36, 37], toplength: [24, 26] },
  { size: 'L', bust: [38, 39], toplength: [25, 27] },
  { size: 'XL', bust: [40, 41], toplength: [25, 27] },
  { size: 'XXL', bust: [42, 43], toplength: [25, 27] },
  { size: '3XL', bust: [44, 45], toplength: [26, 28] },
  { size: '4XL', bust: [46, 47], toplength: [26, 28] },
  { size: '5XL', bust: [48, 49], toplength: [26, 28] },
  { size: '6XL', bust: [50, 51], toplength: [28, 29] },
  { size: '7XL', bust: [52, 53], toplength: [29, 30] },
];
const createTshirtTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Bust (${unit})</th>
          <th>Top Length (${unit})</th>
                  </tr>
      </thead>
      <tbody>
  `;
tshirtSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.bust?.[0]))} ${safeSpan(convert(row.bust?.[1]))}</td>
        <td>${safeSpan(convert(row.toplength?.[0]))} ${safeSpan(convert(row.toplength?.[1]))}</td>
              </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};
document.querySelectorAll('.tshirt-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.tshirtSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createTshirtTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createTshirtTable(true);
  });

  // Initial table
  container.innerHTML = createTshirtTable(false);
});

/* --------------------------------------------------------------------------------------------------------------------------- */

/* Tunic body measurements Size Chart */
const tunicSizeData = [
  { size: 'XS', bust: [32, 33], toplength: [23, 25] },
  { size: 'S', bust: [34, 35], toplength: [24, 26] },
  { size: 'M', bust: [36, 37], toplength: [24, 26] },
  { size: 'L', bust: [38, 39], toplength: [25, 27] },
  { size: 'XL', bust: [40, 41], toplength: [25, 27] },
  { size: 'XXL', bust: [42, 43], toplength: [25, 27] },
  { size: '3XL', bust: [44, 45], toplength: [26, 28] },
  { size: '4XL', bust: [46, 47], toplength: [26, 28] },
  { size: '5XL', bust: [48, 49], toplength: [26, 28] },
  { size: '6XL', bust: [50, 51], toplength: [28, 29] },
  { size: '7XL', bust: [52, 53], toplength: [29, 30] },
];
const createTunicTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Bust (${unit})</th>
          <th>Top Length (${unit})</th>
                  </tr>
      </thead>
      <tbody>
  `;
tunicSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.bust?.[0]))} ${safeSpan(convert(row.bust?.[1]))}</td>
        <td>${safeSpan(convert(row.toplength?.[0]))} ${safeSpan(convert(row.toplength?.[1]))}</td>
              </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};
document.querySelectorAll('.tunic-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.tunicSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createTunicTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createTunicTable(true);
  });

  // Initial table
  container.innerHTML = createTunicTable(false);
});

/* --------------------------------------------------------------------------------------------------------------------------- */

/* Pants measurements Size Chart */
const pantsSizeData = [
  { size: 'XS', waist: [26, 27], hip: [36, 37], fulllength: [37] },
  { size: 'S', waist: [28, 29], hip: [38, 39], fulllength: [38] },
  { size: 'M', waist: [30, 31], hip: [40, 41], fulllength: [38] },
  { size: 'L', waist: [32, 33], hip: [42, 43], fulllength: [38] },
  { size: 'XL', waist: [34, 35], hip: [44, 45], fulllength: [39] },
  { size: 'XXL', waist: [36, 37], hip: [46, 47], fulllength: [39] },
  { size: '3XL', waist: [38, 39], hip: [48, 49], fulllength: [39] },
  { size: '4XL', waist: [40, 41], hip: [50, 51], fulllength: [40] },
  { size: '5XL', waist: [42, 43], hip: [52, 53], fulllength: [40] },
  { size: '6XL', waist: [44, 45], hip: [54, 55], fulllength: [41] },
  { size: '7XL', waist: [46, 47], hip: [56, 57], fulllength: [41] },
];
const createPantsTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Waist (${unit})</th>
          <th>Hip (${unit})</th>
          <th>Full Length (${unit})</th>
        </tr>
      </thead>
      <tbody>
  `;

  pantsSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.waist?.[0]))} ${safeSpan(convert(row.waist?.[1]))}</td>
        <td>${safeSpan(convert(row.hip?.[0]))} ${safeSpan(convert(row.hip?.[1]))}</td>
        <td>${safeSpan(convert(row.fulllength?.[0]))} ${safeSpan(convert(row.fulllength?.[1]))}</td>
      </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};
document.querySelectorAll('.pants-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.pantsSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createPantsTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createPantsTable(true);
  });

  // Initial table
  container.innerHTML = createPantsTable(false);
});

/* --------------------------------------------------------------------------------------------------------------------------- */

/* Trousers and Pants measurements Size Chart */
const trousersandpantsSizeData = [
  { size: 'XS', waist: [26, 27], hip: [36, 37], fulllength: [37] },
  { size: 'S', waist: [28, 29], hip: [38, 39], fulllength: [38] },
  { size: 'M', waist: [30, 31], hip: [40, 41], fulllength: [38] },
  { size: 'L', waist: [32, 33], hip: [42, 43], fulllength: [38] },
  { size: 'XL', waist: [34, 35], hip: [44, 45], fulllength: [39] },
  { size: 'XXL', waist: [36, 37], hip: [46, 47], fulllength: [39] },
  { size: '3XL', waist: [38, 39], hip: [48, 49], fulllength: [39] },
  { size: '4XL', waist: [40, 41], hip: [50, 51], fulllength: [40] },
  { size: '5XL', waist: [42, 43], hip: [52, 53], fulllength: [40] },
  { size: '6XL', waist: [44, 45], hip: [54, 55], fulllength: [41] },
  { size: '7XL', waist: [46, 47], hip: [56, 57], fulllength: [41] },
];
const createTrousersandpantsTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Waist (${unit})</th>
          <th>Hip (${unit})</th>
          <th>Full Length (${unit})</th>
        </tr>
      </thead>
      <tbody>
  `;

  trousersandpantsSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.waist?.[0]))} ${safeSpan(convert(row.waist?.[1]))}</td>
        <td>${safeSpan(convert(row.hip?.[0]))} ${safeSpan(convert(row.hip?.[1]))}</td>
        <td>${safeSpan(convert(row.fulllength?.[0]))} ${safeSpan(convert(row.fulllength?.[1]))}</td>
      </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};
document.querySelectorAll('.trousersandpants-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.trousersandpantsSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createTrousersandpantsTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createTrousersandpantsTable(true);
  });

  // Initial table
  container.innerHTML = createTrousersandpantsTable(false);
});

/* --------------------------------------------------------------------------------------------------------------------------- */

/* Skirts measurements Size Chart */
const skirtsSizeData = [
  { size: 'XS', waist: [26, 27], hip: [36, 37], fulllength: [37] },
  { size: 'S', waist: [28, 29], hip: [38, 39], fulllength: [38] },
  { size: 'M', waist: [30, 31], hip: [40, 41], fulllength: [38] },
  { size: 'L', waist: [32, 33], hip: [42, 43], fulllength: [38] },
  { size: 'XL', waist: [34, 35], hip: [44, 45], fulllength: [39] },
  { size: 'XXL', waist: [36, 37], hip: [46, 47], fulllength: [39] },
  { size: '3XL', waist: [38, 39], hip: [48, 49], fulllength: [39] },
  { size: '4XL', waist: [40, 41], hip: [50, 51], fulllength: [40] },
  { size: '5XL', waist: [42, 43], hip: [52, 53], fulllength: [40] },
  { size: '6XL', waist: [44, 45], hip: [54, 55], fulllength: [41] },
  { size: '7XL', waist: [46, 47], hip: [56, 57], fulllength: [41] },
];
const createSkirtsTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Waist (${unit})</th>
          <th>Hip (${unit})</th>
          <th>Full Length (${unit})</th>
        </tr>
      </thead>
      <tbody>
  `;

  skirtsSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.waist?.[0]))} ${safeSpan(convert(row.waist?.[1]))}</td>
        <td>${safeSpan(convert(row.hip?.[0]))} ${safeSpan(convert(row.hip?.[1]))}</td>
        <td>${safeSpan(convert(row.fulllength?.[0]))} ${safeSpan(convert(row.fulllength?.[1]))}</td>
      </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};
document.querySelectorAll('.skirts-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.skirtsSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createSkirtsTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createSkirtsTable(true);
  });

  // Initial table
  container.innerHTML = createSkirtsTable(false);
});


/* --------------------------------------------------------------------------------------------------------------------------- */
/* Topwear body measurements Size Chart */
const topwearSizeData = [
  { size: 'XS', bust: [32, 33], toplength: [23, 25] },
  { size: 'S', bust: [34, 35], toplength: [24, 26] },
  { size: 'M', bust: [36, 37], toplength: [24, 26] },
  { size: 'L', bust: [38, 39], toplength: [25, 27] },
  { size: 'XL', bust: [40, 41], toplength: [25, 27] },
  { size: 'XXL', bust: [42, 43], toplength: [25, 27] },
  { size: '3XL', bust: [44, 45], toplength: [26, 28] },
  { size: '4XL', bust: [46, 47], toplength: [26, 28] },
  { size: '5XL', bust: [48, 49], toplength: [26, 28] },
  { size: '6XL', bust: [50, 51], toplength: [28, 29] },
  { size: '7XL', bust: [52, 53], toplength: [29, 30] },
];
const createTopwearTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Bust (${unit})</th>
          <th>Top Length (${unit})</th>
                  </tr>
      </thead>
      <tbody>
  `;
topwearSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.bust?.[0]))} ${safeSpan(convert(row.bust?.[1]))}</td>
        <td>${safeSpan(convert(row.toplength?.[0]))} ${safeSpan(convert(row.toplength?.[1]))}</td>
              </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};
document.querySelectorAll('.tops-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.topwearSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createTopwearTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createTopwearTable(true);
  });

  // Initial table
  container.innerHTML = createTopwearTable(false);
});

/* --------------------------------------------------------------------------------------------------------------------------- */

/* Sweaters body measurements Size Chart */
const sweatersSizeData = [
  { size: 'XS', bust: [32, 33], waist: [26, 27], hip: [36, 37] },
  { size: 'S', bust: [34, 35], waist: [28, 29], hip: [38, 39] },
  { size: 'M', bust: [36, 37], waist: [30, 31], hip: [40, 41] },
  { size: 'L', bust: [38, 39], waist: [32, 33], hip: [42, 43] },
  { size: 'XL', bust: [40, 41], waist: [34, 35], hip: [44, 45] },
  { size: 'XXL', bust: [42, 43], waist: [36, 37], hip: [46, 47] },
  { size: '3XL', bust: [44, 45], waist: [38, 39], hip: [48, 49] },
  { size: '4XL', bust: [46, 47], waist: [40, 41], hip: [50, 51] },
  { size: '5XL', bust: [48, 49], waist: [42, 43], hip: [52, 53] },
  { size: '6XL', bust: [50, 51], waist: [44, 45], hip: [54, 55] },
  { size: '7XL', bust: [52, 53], waist: [46, 47], hip: [56, 57] },
];
const createSweatersTable = (isCm = false) => {
  const unit = isCm ? 'cm' : 'in';
  const safeSpan = (val) => val !== undefined ? `<span>${val}</span>` : '';
  const convert = (val) => {
    if (val === undefined) return;
    if (isCm) return Math.round(inchToCm(val)); // round after converting to cm
    return val;
  };

  let table = `
    <table class="size-table">
      <thead>
        <tr>
          <th>Size</th>
          <th>Bust (${unit})</th>
          <th>Waist (${unit})</th>
          <th>Hip (${unit})</th>
        </tr>
      </thead>
      <tbody>
  `;

  sweatersSizeData.forEach(row => {
    table += `
      <tr>
        <td>${row.size}</td>
        <td>${safeSpan(convert(row.bust?.[0]))} ${safeSpan(convert(row.bust?.[1]))}</td>
        <td>${safeSpan(convert(row.waist?.[0]))} ${safeSpan(convert(row.waist?.[1]))}</td>
        <td>${safeSpan(convert(row.hip?.[0]))} ${safeSpan(convert(row.hip?.[1]))}</td>
      </tr>
    `;
  });

  table += `</tbody></table>`;
  return table;
};
document.querySelectorAll('.sweaters-size-chart-block').forEach(block => {
  const inBtn = block.querySelector('.inBtn');
  const cmBtn = block.querySelector('.cmBtn');
  const container = block.querySelector('.sweatersSizeChartContainer');

  if (!inBtn || !cmBtn || !container) return;

  inBtn.addEventListener('click', () => {
    inBtn.classList.add('active');
    cmBtn.classList.remove('active');
    container.innerHTML = createSweatersTable(false);
  });

  cmBtn.addEventListener('click', () => {
    cmBtn.classList.add('active');
    inBtn.classList.remove('active');
    container.innerHTML = createSweatersTable(true);
  });

  // Initial table
  container.innerHTML = createSweatersTable(false);
});

/* --------------------------------------------------------------------------------------------------------------------------- */



